import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import { WinModalGallery } from "../windows/ModalGallery";
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics } from '../_app/cuchillo/core/Basics';

export default class Project extends Default {
  _media;
  _calls = {
    click: (e) => this.click(e)
  }

  constructor() {
    super();

    if (!this.isFirstTime) this.executeScriptsFrom(this.container);
  }

  initGallery() {
    this._media = GetBy.class('__media', this.container);
    for (let i = 0; i < this._media.length; i++) {
      const media = this._media[i];

      media.setAttribute('data-index', i);
      media.addEventListener(Basics.clickEvent, this._calls.click);
      media.style.cursor = 'pointer';
    }

    WinModalGallery.init(this.container.dataset.id);
  }

  executeScriptsFrom(container) {
    const scripts = container.querySelectorAll('script');


    scripts.forEach(oldScript => {
      const newScript = document.createElement('script');

      [...oldScript.attributes].forEach(attr =>
        newScript.setAttribute(attr.name, attr.value)
      );

      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  click(e) {
    WinModalGallery.show(parseInt(e.currentTarget.dataset.index));
  }

  afterShow() {
    super.afterShow();
    this.initGallery();
  }

  resize() {
    super.resize();
    WinModalGallery.resize();
  }

  afterHide() {
    super.afterHide();

    for (let i = 0; i < this._media.length; i++) {
      const media = this._media[i];
      media.removeEventListener(Basics.clickEvent, this._calls.click);
    }

    WinModalGallery.destroy();
  }
}

ControllerPage._addPage('project', Project);
